import React from 'react';
import './Checkbox.scss';

interface ICheckbox {
  /**
  * The ID of the checkbox
  */
  id?: string,
  /**
   * The checked state of the checkbox
   */
  checked: any,
  /**
   * The callback when a checkbox is selected
   */
  onClick: () => void,
  /**
   * Whether or not the user has to tick these checkboxes
   */
  required?: boolean,
  /**
   * The name of the checkbox option could be either a string or a node (plain html)
   */
  content: any,
  /**
   * The design style of the checkbox
   */
  checkType?: "general",
  /**
   * The value of the checkbox
   */
  value: string | number,
  /**
   * instead of pure text the caller pass html content
   */
  isHtml?: boolean

  /*
   * Remove margin if it's true
   */
  noMargin?: boolean
}

const Checkbox: React.FC<ICheckbox> = (props) => {
  const {
    id,
    checked,
    onClick,
    required = false,
    content: Content,
    checkType = "general",
    value,
    isHtml = false,
    noMargin = false
  } = props;

  return (
    <div className={`cc-checkbox ${!noMargin ? `cc-checkbox--margin-bottom` : ''}`} onClick={onClick}>
      <input
        id={id}
        className={`cc-checkbox-${checkType}__input`}
        type="checkbox"
        checked={checked}
        onClick={evt => { evt.preventDefault(); evt.stopPropagation(); }}
        onChange={evt => { evt.preventDefault(); evt.stopPropagation(); }}
        //onClick={onClick}
        //onChange={onClick}
        required={required}
        value={value}
      />
      {checked ? <i className={`fas fa-check-circle fa-2x cc-checkbox-${checkType}__icon`}/> : <i className={`fal fa-circle fa-2x cc-checkbox-${checkType}__icon`}/>}
      <label className={`cc-checkbox-${checkType}__label`} htmlFor={id}>{isHtml ? <Content /> : Content}</label>
    </div>

  );
}

export default Checkbox;
